import "flyonui/flyonui";
import _ from "lodash";
import GenericUpdatePage  from "./update-lib";
import ScrollSpy from "../lib/scrollspy";
import LambdaShaders from "../lib/shaders";


window.addEventListener('load', function() {

    GenericUpdatePage.init();

    let scrollSpy = new ScrollSpy({menu: "#navigation", container: "#scrollspy"});

    LambdaShaders.loadShaders();

    var loader = document.querySelector("#update-loader");
    loader.style.display = "none";

});

window.GenericUpdatePage = GenericUpdatePage;